<script>
import { imgHost2 } from "@/config/index";


export default {
  props: {
    planData: {
      type: Array | Object,
      default: () => []
    },
    curHea: {
      type: String,
      default: ''
    }
  },
  computed: {
    dataType () {
      return Array.isArray(this.planData) ? 'array' : 'object';
    }
  },
  data () {
    return {
      imgHost2
    };
  }
}
</script>

<template>
  <div v-if="planData && dataType === 'array'" class="disease-about">
    <div class="disease-about-text disease-about-l">
      {{ planData[0].symptom || '' }}
    </div>
    <div class="disease-about-text disease-about-m">
      {{ planData[1].symptom || '' }}
    </div>
    <div class="disease-about-text disease-about-h">
      {{ planData[2].symptom || '' }}
    </div>
    <div class="disease-about-step">
      <div class="disease-about-step-item">
        <div class="disease-about-step-item-content">
          {{ planData[0].ne || '' }}
        </div>
      </div>
      <div class="disease-about-step-item">
        <div class="disease-about-step-item-content">
          {{ planData[1].ne || '' }}
        </div>
      </div>
      <div class="disease-about-step-item">
        <div class="disease-about-step-item-content">
          {{ planData[2].ne || '' }}
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="planData && dataType === 'object'" class="disease-about">
    <div class=" disease-about-text disease-about-l">
      {{ planData.L.symptom || '' }}
    </div>
    <div class="disease-about-text disease-about-m">
      {{ planData.M.symptom || '' }}
    </div>
    <div class="disease-about-text disease-about-h">
      {{ planData.H.symptom || '' }}
    </div>
    <div class="disease-about-step">
      <div class="disease-about-step-item">
        <div class="disease-about-step-item-content">
          {{ planData.L.ne || '轻度' }}
        </div>
      </div>
      <div class="disease-about-step-item">
        <div class="disease-about-step-item-content">
          {{ planData.M.ne || '中度' }}
        </div>
      </div>
      <div class="disease-about-step-item">
        <div class="disease-about-step-item-content">
          {{ planData.H.ne || '重度' }}
        </div>
      </div>
    </div>
  </div>
  <div v-else class="disease-about-none">
    <p class="disease-about-none-text">
      暂无相关症状描述
    </p>
  </div>
</template>

<style lang="scss" scoped>
.disease-about {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr auto 1fr;
  grid-template-areas: 'l s h' 'step step step' 'a m b';

  >div {
    position: relative;
    width: 100%;
  }

  &-text {
    padding: 20px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    background-color: #edf0ff;
    border-radius: 16px;
  }

  &-l {
    grid-area: l;
  }

  &-m {
    grid-area: m;
  }

  &-h {
    grid-area: h;
  }

  &-step {
    grid-area: step;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-gap: 10px;
    padding: 20px 0;


    &::after {
      content: '';
      position: absolute;
      top: calc(50% - 8px);
      left: 0;
      width: 100%;
      height: 16px;
      border-radius: 12px;
      z-index: -1;
      background-image: linear-gradient(to right,
          #4ea4ff,
          #4869ff,
          #ffd129,
          #ff8929,
          #ff864e,
          #fd3c3c);
    }

    >div {
      position: relative;
      width: 100%;
      display: flex;

      &:nth-child(1) {
        >div {
          background-image: linear-gradient(45deg, #4ea4ff, #4869ff);
        }
      }

      &:nth-child(2) {
        >div {
          background-image: linear-gradient(45deg, #ffd129, #ff8929);
        }
      }

      &:nth-child(3) {
        >div {
          background-image: linear-gradient(45deg, #ff864e, #fd3c3c);
        }
      }
    }

    &-item {
      position: relative;
      width: 100%;

      &-content {
        position: relative;
        width: 100%;
        font-size: 18px;
        margin: auto;
        padding: 10px 20px;
        border-radius: 16px;
        color: #fff;
        text-align: center;
      }
    }
  }
}

//</style>
